<template>
	<div class="login-register-bg">
		<div class="login-box">
			<div class="top-tab" v-show="cur == 0 || cur == 1">
				<div class="tab" :class="{'on': cur === index }" v-for="(item,index) in navList" :key="index"
					@click="changeNav(index)">{{item}}</div>
			</div>
			<div class="input-box" v-show="cur == 0">
				<div class="title">手机号</div>
				<div class="input-item">
					<input v-model="mobile" placeholder="请输入手机号" />
				</div>

				<div class="title">密码</div>
				<div class="input-item">
					<input v-model="password" :type="showPassword? 'text': 'password' " @keydown.enter="login_system" placeholder="请输入密码" />
					<img class="eye" :src="eyeImg" @click="changeType" />

				</div>
				<div class="forget-box">
					<div class="forget" @click="cur = 2">忘记密码</div>
					<label @click="changeRememberMe">
						<img class="remember-img" :src="rememberImg" />
						<span>记住密码</span>
					</label>
				</div>
				<div class="login-button bg-main" @click="login_system">登录</div>
			</div>
			
			<div class="input-box" v-show="cur == 1">
				<div class="title">手机号</div>
				<div class="input-item">
					<input v-model="account" @blur="checkMoblie" placeholder="请输入手机号" />
				</div>
				<div class="title">密码</div>
				<div class="input-item">
					<input v-model="register_psw" :type="showPassword? 'text': 'password' " placeholder="请输入密码" />
					<img class="eye" :src="eyeImg" @click="changeType" />
				</div>
				<div class="title">验证码</div>
				<div class="input-item">
					<input v-model="valid_code" placeholder="请输入短信验证码" @keydown.enter="registerAccount" />
					<button class="send-code" :disabled="disabled"><span
							@click="sendCode(registerScene)">{{ captchaTxt }}</span></button>
				</div>
				<div class="login-button bg-main" @click="registerAccount">立即注册</div>
			</div>
			
			<div class="top-tab" v-show="cur == 2 ">
				<div class="tab" style="width: 100%; color: #303030;">忘记密码</div>
			</div>
			<div class="input-box" v-show="cur == 2 ">
				<div class="title">手机号</div>
				<div class="input-item">
					<input v-model="forget.mobile" @blur="checkForgetMoblie" placeholder="请输入手机号" />
				</div>
				<div class="title">验证码</div>
				<div class="input-item">
					<input v-model="valid_code" placeholder="请输入短信验证码" />
					<button class="send-code" :disabled="disabled"><span
							@click="sendCode(forgetScene)">{{ captchaTxt }}</span></button>
				</div>
				<div class="title">新密码</div>
				<div class="input-item">
					<input v-model="forget.password" :type="showPassword? 'text': 'password' " @keydown.enter="findPsd" placeholder="请输入新密码" />
					<img class="eye" :src="eyeImg" @click="changeType" />
				</div>
				
				<div class="forget-box">
					<div class="forget" @click="cur = 0">已有账号，立即登录</div>
					<div class="forget" @click="cur = 1">注册新账号</div>
				</div>
				<div class="login-button bg-main" @click="findPsd">提交</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		accountLogin,
		profile,
		register,
		validMobile,
		sendSms,
		findPassword
	} from "@/api/index.js"
	import localStorage from '@/utils/localStorage.js'
	export default {
		name: "Login",
		data() {
			return {
				cur: 0,
				navList: ["登录", "注册"],
				mobile: localStorage.get('REMEMBER_ACCOUNT') || '',
				password: localStorage.get('REMEMBER_PSW') || '',
				account:'',
				register_psw:'',
				showPassword: false,
				rememberMe: localStorage.get('REMEMBER_ME') || false,
				valid_code: "",
				captchaTxt: "发送验证码",
				disabled: false,
				is_register:false,
				forget:{
					mobile:'',
					password:'',
				},
				registerScene:'Account Register',
				forgetScene:'Set Password',
				has_account:true
				
			};
		},
		computed: {
			eyeImg() {
				return this.showPassword ?
					require("../assets/images/login-register/hide@2x.png") :
					require("../assets/images/login-register/dieplay@2x.png");
			},
			rememberImg() {
				return this.rememberMe ?
					require("../assets/images/login-register/select@2x.png") :
					require("../assets/images/login-register/normal@2x.png");
			},
		},
		methods: {
			changeNav(cur) {
				this.cur = cur;
			},
			changeType() {
				this.showPassword = !this.showPassword;
			},
			changeRememberMe() {
				this.rememberMe = !this.rememberMe;
			},
			sendCode(scene) {
				if(this.disabled) {
					return
				}
				let mobile = ''
				if(scene == this.forgetScene){
					mobile = this.forget.mobile
				}
				if(scene == this.registerScene){
					mobile = this.account
				}
				if(scene == this.registerScene && !this.account) {
					this.$Notice.warning({
						title: '请输入手机号'
					});
					mobile = this.account
					return
				}
				if(scene == this.forgetScene && !this.forget.mobile) {
					this.$Notice.warning({
						title: '请输入手机号'
					});
					
					return
				}
				
				if(scene == this.registerScene && this.is_register) {
					this.$Notice.warning({
						title: '该手机号已注册'
					});
					return
				}
				if(scene == this.forgetScene && !this.has_account) {
					this.$Notice.warning({
						title: '该手机号未注册'
					});
					return
				}
				
				sendSms({
					mobile,
					scene
				}).then((res)=>{
					//console.log(res)
					if(res.code == 0) {
						this.countDown();
					}
				})

			},
			countDown() {
				if (this.disabled) return;
				this.disabled = true;
				let second = 60;
				this.captchaTxt = `${second}s后重新获取`;
				const timer = setInterval(() => {
					second--;
					this.captchaTxt = `${second}s后重新获取`;
					if (second < 1) {
						clearInterval(timer);
						this.disabled = false;
						this.captchaTxt = "发送验证码";
					}
				}, 1000);
			},
			
			login_system() {
				this.login(this.mobile, this.password).catch(err => {
					this.$Notice.error({
						title: err.msg
					})
				})
			},
			async login(account,password) {
				let data = {
					account,
					password
				}
				let login = await accountLogin(data)

				this.$store.commit('login', login.data)
				if(this.rememberMe) {
					localStorage.set('REMEMBER_ACCOUNT',account)
					localStorage.set('REMEMBER_PSW',password)
					localStorage.set('REMEMBER_ME',true)
				}
				let user = await profile()
				this.$store.commit('setUserInfo', user.data)
				this.$router.replace('/')
				this.$Notice.success({
					title:'登录成功'
				})
			},
			async checkMoblie() {
				if(!this.account) {
					return
				}
				let json = await validMobile({
					account: this.account,
					from:'register'
				})
				if(json.data.is_register) {
					this.$Notice.warning({
						title: '该手机号已注册'
					});
					this.is_register = true
					return
				}
				this.is_register = false
			},
			async checkForgetMoblie() {
				if(!this.forget.mobile) {
					return
				}
				let json = await validMobile({
					account: this.forget.mobile,
					from:'findpwd'
				})
				if(!json.data.has_account) {
					this.$Notice.warning({
						title: '该手机号未注册'
					});
					this.has_account = false
					return
				}
				this.has_account = true
			},
			async registerAccount() {
				register({
					account: this.account,
					password: this.register_psw,
					valid_code: this.valid_code
				}).then(()=>{
					this.login(this.account,this.register_psw)
				}).catch((res)=>{
					this.$Notice.warning({
						title: res.msg
					});
				})
			},
			async findPsd() {
				if(!this.forget.mobile) {
					this.$Notice.warning({
						title: '请输入手机号'
					});
					return
				}
				if(!this.valid_code) {
					this.$Notice.warning({
						title: '请输入短信验证码'
					});
					return
				}
				if(!this.forget.password) {
					this.$Notice.warning({
						title: '请输入密码'
					});
					return
				}
				findPassword({
					account: this.forget.mobile,
					password: this.forget.password,
					valid_code: this.valid_code
				}).then(()=>{
					this.$Notice.success({
						title: '修改成功'
					});
					localStorage.remove('REMEMBER_ACCOUNT')
					localStorage.remove('REMEMBER_PSW')
					this.password = ''
					this.cur = 0
				}).catch((res)=>{
					this.$Notice.warning({
						title: res.msg
					});
				})
			}
		},
	};
</script>

<style scoped lang="scss">
	.login-register-bg {
		background-image: url(../assets/images/login-register/bg@2x.png);
		width: 100%;
		height: 612px;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		position: relative;

		.login-box {
			width: 460px;
			// height: 522px;
			background: #ffffff;
			opacity: 1;
			border-radius: 10px;
			position: absolute;
			top: 45px;
			right: 60px;

			.top-tab {
				display: flex;
				text-align: center;
				justify-content: center;
				align-items: center;
				margin-top: 45px;

				.tab {
					width: 38px;
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #999999;
					position: relative;
					margin: 0 30px;
					height: 35px;
					cursor: pointer;
					&.on {
						color: #303030;
						font-weight: bold;

						&::after {
							content: "";
							width: 38px;
							height: 2px;
							background: #000000;
							position: absolute;
							bottom: 0;
							left: 0;
							right: 0;
							z-index: 1;
						}
					}
				}
			}

			.input-box {
				text-align: left;
				margin: 15px 30px 35px 30px;
				width: 400px;

				.title {
					margin-top: 20px;
					font-size: 14px;
					font-family: PingFang SC;
					font-weight: bold;
					line-height: 22px;
					color: #000000;
				}

				.input-item {
					margin-top: 5px;
					width: 400px;
					height: 42px;
					background: #ffffff;
					border: 1px solid #9b9b9b;
					position: relative;

					input {
						border: none;
						height: 95%;
						width: 100%;
						border: none;
						padding-left: 10px;
					}
				}

				.eye {
					width: 20px;
					height: 10px;
					position: absolute;
					right: 10px;
					top: 20px;
				}

				.send-code {
					position: absolute;
					right: 10px;
					top: 12px;
					font-size: 15px;
					font-family: PingFang SC;
					font-weight: bold;
					line-height: 15px;
					color: #0f114a;
					border: none;
					background: none;
					cursor: pointer;
				}
			}

			.forget-box {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: #999999;

				.forget {
					color: #0f114a;
					cursor: pointer;
				}

				label {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				img {
					width: 15px;
					height: 15px;
					margin-right: 5px;
				}
			}

			.login-button {
				width: 400px;
				height: 50px;
				line-height: 50px;
				text-align: center;
				border-radius: 2px;
				font-size: 18px;
				font-weight: bold;
				margin-top: 20px;
				letter-spacing: 5px;
				cursor: pointer;
			}
		}
	}
</style>
